import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { AlertService } from 'features/alerts/service/service'

export { AlertService } from 'features/alerts/service/service'
export type {
  AlertBody,
  AlertResponse,
  AlertType,
  AlertUser,
} from 'features/alerts/service/types'

export function useAlertService(): AlertService {
  const client = useApiClient()
  return useMemo(() => new AlertService(client), [client])
}
